module.exports = __webpack_public_path__ + "img/carnival-loader.bb52e266.svg";